import React, { useContext } from 'react'
import styled, { useTheme } from 'styled-components'
import { Link } from 'gatsby'
import Dropdown from '@talus-analytics/library.ui.dropdown'

import CMS from '@talus-analytics/library.airtable-cms'
import useNavData from '../../cmsHooks/useNavData'
import { PaletteContext } from 'styles/PaletteProvider'

import ContentContainer from '../layout/ContentContainer'
import device from '../../utilities/device'
import { capitalize } from 'utilities/language'
import Center from '../layout/Center'
import PageLink from 'components/navigation/PageLink'
import ResourceSearch from 'clientPages/landing/landingComponents/ResourceSearch'

const NavContainer = styled.nav`
  width: 100%;
  position: sticky;
  z-index: 10;
  top: 0;
  background-color: ${({ theme }) => theme.backgroundAlternate};
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.25);
  a {
    color: ${({ theme }) => theme.primary};
    &:hover {
      color: ${({ theme }) => theme.links};
    }
  }
`
const Layout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`
const LinksContainer = styled.div`
  a:not(:last-child) {
    margin-right: 20px;
  }
  @media ${device.tablet} {
    display: none;
  }
`
const MobileMenu = styled.div`
  display: none;
  position: relative;
  margin-left: 1rem;
  @media ${device.tablet} {
    display: block;
  }
  > div {
  }
`
const MobileMenuButton = styled.button`
  height: 2rem;
  width: 2rem;
  border: none;
  padding: 0.25rem;
  background-color: transparent;
`
const MobileButtonDropdown = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 1rem;
  background-color: ${({ theme }) => theme.backgroundAlternate};
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.25);
  a {
    color: ${({ theme }) => theme.primary};
    &:hover {
      color: ${({ theme }) => theme.links};
    }
    &:not(:last-of-type) {
      margin-bottom: 0.5rem;
      text-align: right;
    }
  }
`
const Logo = styled.div`
  margin-right: 1rem;
`
const SiteName = styled.p`
  font-size: 1.2rem;
  ${({ theme }) => theme.textStyleSiteTitle}
`
const DesktopResourceSearch = styled.div`
  max-width: 500px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 1.5rem;
  @media ${device.laptop} {
    display: none;
  }
  > div > div form {
    margin-top: 0px;
  }
`
const RightSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`
const StyledPageLink = styled(PageLink)`
  &:hover {
    text-decoration: none;
  }
`

const Nav = () => {
  const data = useNavData()
  const palette = useContext(PaletteContext)

  const theme: any = useTheme()

  const links = (
    <>
      <StyledPageLink page={'explore'}>
        <CMS.Text data={data} name={'Explore link'} />
      </StyledPageLink>
      <StyledPageLink page={'about'}>
        <CMS.Text data={data} name={'About link'} />
      </StyledPageLink>
      <StyledPageLink page={'contact'}>
        <CMS.Text data={data} name={'Contact link'} />
      </StyledPageLink>
    </>
  )

  return (
    <NavContainer>
      <ContentContainer verticalPadding={'20px'}>
        <Layout>
          <Link to="/">
            <Center row cross>
              {palette !== null && (
                // return either light mode or dark mode logo
                // depending on which palette is active
                <Logo>
                  <CMS.Image
                    data={data}
                    name={capitalize(palette) + ' mode logo'}
                  />
                </Logo>
              )}
              <SiteName>
                <CMS.Text data={data} name={'Site name'} />
              </SiteName>
            </Center>
          </Link>
          <RightSide>
            <DesktopResourceSearch>
              <ResourceSearch nav />
            </DesktopResourceSearch>
            <LinksContainer>{links}</LinksContainer>
            <MobileMenu>
              <Dropdown
                renderButton={() => (
                  <MobileMenuButton>
                    <CMS.Icon name="Hamburger" color={theme.primary} />
                  </MobileMenuButton>
                )}
                expanderStyle={{ right: '0px' }}
              >
                <MobileButtonDropdown>{links}</MobileButtonDropdown>
              </Dropdown>
            </MobileMenu>
          </RightSide>
        </Layout>
      </ContentContainer>
    </NavContainer>
  )
}

export default Nav
